export const locale = {
    lang: 'en',
    data: {
        'AUTHENTICATION': {
            'WELCOME': ' Welcome to SmartBiometrik!',
            'THANKS': 'Thanks for using SmartBiometrik!',
            'SEE_YOU_SOON': 'See you soon!',
        }
    }
};
